import { render } from "./Featured.vue?vue&type=template&id=873e9d96&scoped=true"
import script from "./Featured.vue?vue&type=script&lang=js"
export * from "./Featured.vue?vue&type=script&lang=js"

import "./Featured.vue?vue&type=style&index=0&id=873e9d96&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-873e9d96"

export default script